import { Component, Input, OnInit } from '@angular/core';
import { SealMaterial } from '../../../models';

@Component({
  selector: 'app-seal-materials',
  templateUrl: './seal-materials.component.html',
  styleUrls: ['./seal-materials.component.scss']
})
export class SealMaterialsComponent implements OnInit {
  @Input() sealMaterials: SealMaterial[] = [];

  get sealMaterialsWithFootnotes(): {
    seals: SealMaterial[],
    footnotes: { notation: string, note: string }[]
  } {
    const uniqueNotes = this.sealMaterials
      .filter(material => (material.note ?? '').length > 0)
      .map(material => material.note).filter((v, i, a) => a.indexOf(v) === i);

    const footnotes = uniqueNotes.filter(v => v.length > 0).map((n, i) => ({
      notation: ''.padStart(i + 1, '*'),
      note: n
    }));

    const sealMaterials: SealMaterial[] = this.sealMaterials.map(v => {
      const footnote = footnotes.find(f => v.note === f.note);
      if (!footnote) return v;
      return { ...v, sealMaterial: `${footnote.notation} ${v.sealMaterial}` };
    })

    return {
      seals: sealMaterials,
      footnotes
    };

  };

  constructor() { }

  ngOnInit(): void {
  }

}
